import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5fd5da54"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "bg-light mb-2 py-1 px-2 shadow-sm rounded" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "py-2 mb-3 text-primary border-bottom" }, "Com quanto você deseja contribuir?", -1));
const _hoisted_3 = { class: "d-flex flex-wrap justify-content-center valores-sugeridos" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "valor-sugerido" };
const _hoisted_6 = { style: { "font-size": "13px", "text-align": "center" } };
const _hoisted_7 = {
    key: 0,
    class: "d-flex justify-content-center"
};
const _hoisted_8 = { class: "form-check custom-control custom-checkbox" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    class: "custom-control-label",
    for: "is_recorrente"
}, "Doar este valor mensalmente", -1));
const _hoisted_10 = { class: "bg-light mb-2 py-1 px-2 shadow-sm rounded" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h5", { class: "py-2 mb-3 text-primary border-bottom" }, "Escolha como doar", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormaPagamento = _resolveComponent("FormaPagamento");
    const _directive_input_format = _resolveDirective("input-format");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.valores, (valor) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "valor-sugerido",
                        key: valor
                    }, [
                        _createElementVNode("button", {
                            href: "#",
                            type: "button",
                            class: _normalizeClass(['mb-1 btn btn-lg btn-block shadow-none', $setup.valorEscolhido === valor ? 'btn-primary active' : 'btn-secondary']),
                            onClick: ($event) => ($setup.setValor(valor, true))
                        }, _toDisplayString($setup.valorSemCentavos(valor)), 11, _hoisted_4)
                    ]));
                }), 128)),
                _createElementVNode("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control text-center", $setup.outroValor ? 'filled' : '']),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.outroValor) = $event)),
                        placeholder: "Outro Valor",
                        onChange: _cache[1] || (_cache[1] = ($event) => ($setup.setValor($setup.outroValor, false))),
                        style: { "margin-bottom": "5px" },
                        autocomplete: "off"
                    }, null, 34), [
                        [_vModelText, $setup.outroValor],
                        [_directive_input_format, 'moeda']
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createTextVNode(" Valor mínimo: "),
                        _createElementVNode("b", null, _toDisplayString($setup.doacao.movimentacao?.forma_pagamento?.valor_minimo), 1)
                    ])
                ])
            ]),
            ($setup.campanha.is_recorrente)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                            id: "is_recorrente",
                            name: "is_recorrente",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (($setup.doacao.is_recorrente) = $event)),
                            class: "custom-control-input",
                            type: "checkbox",
                            onChange: _cache[3] || (_cache[3] = ($event) => ($setup.onChangeRecorrencia()))
                        }, null, 544), [
                            [_vModelCheckbox, $setup.doacao.is_recorrente]
                        ]),
                        _hoisted_9
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_FormaPagamento)
        ])
    ], 64));
}
